import { observer } from 'mobx-react';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Route, Switch, Redirect, __RouterContext } from 'react-router';
import HitoLogo from 'resources/images/hito-left.png';
import { EXPIRED, RESET_PASSWORD, TWO_FACTOR } from '../../routes';
import { profileContext } from '../../state/profileState';
import { appContext } from '../../state/appState';
import { useImages, useTabTitle } from '../../utils/hooks';
import './Login.css';
import { LoginForm } from './LoginForm';
import { ResetForm } from './ResetForm';
import { TwoFactorForm } from './TwoFactorForm';

interface LoginProps {}

export const Login: FC<LoginProps> = observer((props) => {
  useTabTitle(`${window.COMPANY_LABEL} Client Portal`);
  
  const profileState = useContext(profileContext);
  const appState = useContext(appContext);
  const routerState = useContext(__RouterContext);

  const logoUrl = '/logos/' + appState.theme + '.png';
  const backgroundUrl = '/backgrounds/' + appState.theme + '.png';
  const images = useImages([logoUrl, backgroundUrl, HitoLogo]);

  if (!profileState.initialized) return null;
  if (profileState.authenticated) {
    if (!profileState.passwordExpired) {
      return <Redirect to="/" />;
    }
    if (routerState.location.pathname !== EXPIRED) {
      return <Redirect to={EXPIRED} />;
    }
  }

  return (
    <div className={'Login'}>
      <div
        className={'background ' + (images[backgroundUrl] ? 'fade-in' : '')}
        style={{
          backgroundImage: images[backgroundUrl]
            ? 'url(' + backgroundUrl + ')'
            : '',
        }}
      ></div>
      <main className="white-box">
        <img
          src={logoUrl}
          alt={window.COMPANY_LOGO_ALT}
          className={'jbw-logo' + (images[logoUrl] ? ' ready' : '')}
        />
        <h1 id='clientPortalLabel'>{window.COMPANY_LABEL} Client Portal</h1>
        <Switch>
          <Route path={RESET_PASSWORD} component={ResetForm} />
          <Route path={TWO_FACTOR} component={TwoFactorForm} />
          <Route component={LoginForm} />
        </Switch>
        <img
          src={HitoLogo}
          alt="Hito Edge"
          className={'hito-logo' + (images[HitoLogo] ? ' ready' : '')}
        />
      </main>
    </div>
  );
});
